import { Wrapper } from '../../components/wrapper.component';
import { Budget, BudgetQuoteSection, createEmptySection, PublicQuoteInfo } from '../../store/reselectors/budget.data';
import { EventStatus } from 'globals/store/events.data';
import { eventStatusReselector } from '../../store/reselectors/events.reselector';
import { OnInit, ViewChild, ChangeDetectorRef, Component } from '@angular/core';
import { filterPageTypes, toggleFilterTypes } from 'src/app/store/filters.era';
import { loadLocal } from 'src/app/helpers/helpers';
import { tableFilterTypes } from 'src/app/store/performers.era';
import { JoiEvent, LabelObject } from 'globals/store/events.data';
import { ConfirmDeleteData, openConfirmDeleteGetResult } from 'src/app/components/dialog.confirmDelete.component';
import { saveTable } from '../performers/performerSharedFunctions';
import { openDialogGetResult } from 'src/app/helpers/angular-helpers';
import { QuoteTableData, quoteColumns } from 'src/app/helpers/table-column-types';
import { TableColumn, TableMenuItem } from 'src/app/helpers/table.data';
import { quoteColumnsById } from 'src/app/helpers/table-helpers';
import { NestedTableComponent } from './../../components/nested-table/nested-table.component';
import { JoiResource } from 'globals/store/resources.data';
import { quotesTableReselector, quoteColumnsReselector } from '../../store/reselectors/quotes.reselector';
import { ManageQuoteDialogComponent } from '../resources/manage-quote.component';
import { ButtonListData, ButtonListDialogComponent } from '../../components/dialogues-general/buttonList.dialog.component';
import { ManageQuoteData } from '../../store/reselectors/quotes.data';
import { JoiAccount } from 'globals/store/accounts.data';
import { resourceListReselector } from '../../store/reselectors/entity.decircular.reselector';
import { traceNames } from 'src/app/services/performance.tracking.data';
import { TopMenuComponent } from '../program/top.menu';
import { CommandMenuComponent } from 'src/app/components/nav-bar/command-menu.component';
import { LoaderPaneFragmentComponent } from 'src/app/components/loader/loader-pane-fragment.component';
import { CommonModule, DatePipe } from '@angular/common';

@Component({
    selector: 'budget-quotes',
    templateUrl: './budget-quotes.html',
    styleUrls: ['../../page.scss', './budget-quotes.scss'],
    standalone: true,
    providers: [DatePipe],
    imports: [TopMenuComponent, CommandMenuComponent, NestedTableComponent, LoaderPaneFragmentComponent, CommonModule],
})
export class BudgetQuotesComponent extends Wrapper<BudgetQuotesComponent> implements OnInit {
  budget: Budget
  event: JoiEvent
  eventStatus: EventStatus
  resourceList: JoiResource[]
  filterPage = filterPageTypes.quotes
  filterType = tableFilterTypes.QuotesTable
  quoteColumns = quoteColumns
  columnData: TableColumn[] = []
  columnsById: { [id: string]: TableColumn } = quoteColumnsById
  tableData: QuoteTableData[] = []
  tableRowsById: { [id:string]: QuoteTableData } = {}
  resources: { [eId: string]: JoiResource }
  selectedIds: string[] 
  busy = false
  account: Partial<JoiAccount>

  constructor(private changeDetectorRef: ChangeDetectorRef) {
    super()
    this.uiService.changePageTitle("Quotes", true)
    this.subProp(this.store.select('events', 'event'), 'event')
    this.subProp(this.store.select('accounts', 'account'), 'account')
    this.subProp(this.store.select('resources', 'entities'), 'resources')
    this.selectCallback<{
    quoteTableData: QuoteTableData[];
    quoteTableRowsById: {[key: string]: QuoteTableData }}, any>(quotesTableReselector, null, data => {
      if (!data) {
        this.tableData = [] // for when the last is deleted
        return
      }
      const { quoteTableData, quoteTableRowsById } = data
      this.tableData = quoteTableData
      this.tableRowsById = quoteTableRowsById
    })
    this.loadCondensed()
    this.subCallback(this.store.select('filters', 'toggleFilters', this.filterPage, 'condensed'), _ => this.loadCondensed())
  }

  ngOnInit() {
    this.subProp(this.store.select('budget', 'budget'), 'budget')
    this.subProp(this.store.select('events', 'event'), 'event')
    this.subProp(this.store.select(eventStatusReselector), 'eventStatus')
    this.selectProp(resourceListReselector, null, 'resourceList')
    this.subCallback(this.store.select(quoteColumnsReselector), columnData => {
      this.columnData = columnData
    })
  }
  
  allMenuItems: TableMenuItem[] = [
    { title: 'Delete', method: this.deleteQuotes.bind(this) },
  ]
  
  menuItems: TableMenuItem[] = this.allMenuItems // default to showing all menu items 
  condensed: boolean
  traceNames = traceNames
  @ViewChild(NestedTableComponent) nestedTable: NestedTableComponent<QuoteTableData>

  saveTable() {
    saveTable('quotes', `${this.event.title} quotes table`, this.dialog, this.nestedTable)
  }

  async addQuoteToResource(event) {
    const data: ButtonListData<JoiResource> = {
      x: event.x - 125,
      y: event.y + 27,
      title: 'Resources',
      choiceObjects: this.resourceList,
      choiceKey: 'name',
      selected: null,
      selectedKey: 'id',
      successLabel: 'Add Quote',
      cancelLabel: 'Cancel'
    }
    const { selected, cancelled, submitted } = await openDialogGetResult<{ selected: string, cancelled: boolean, submitted: boolean }>(this.dialog, ButtonListDialogComponent, {
      width: '300px',
      autoFocus: false,
      data,
      backdropClass: 'clear',
    })
    if (!selected || (!submitted && !cancelled)) return
    const resourceId = selected as string
    const resource = this.event.resources[resourceId as string]
    if (!resource) {
      console.log("Missing resource...")
      return
    }
    const quoteId = await this.shareService.generateShareCode()
    const quoteSection: BudgetQuoteSection = { ...createEmptySection(this.account, true, quoteId), resourceId, resourceName: this.resources[resourceId].name || null }
    
    const quoteInfo: PublicQuoteInfo = { eventId: this.event.eventId, resourceId, quoteId, status: 'Off', quoteStatus: 'Pending', accountId: this.account.id }
    console.log("Should be adding a quote with code... " + quoteId, quoteInfo)

    await this.shareService.upsertPublicQuoteInfo(quoteInfo)

    resource.quoteIds.push(quoteId)
    await this.resourceService.updateResource(resource)

    this.budget.quotes[quoteId] = quoteSection
    await this.budgetService.updateBudget(this.event.eventId, this.budget)

    this.manageQuote({ id: quoteId } as QuoteTableData, resourceId)
  }


  setMenu() {
    setTimeout(() => {
      this.menuItems = [...this.allMenuItems]
    })
  }

  selectIds(ids: Set<string>) {
    this.selectedIds = Array.from(ids)
    this.setMenu()
  }

  async manageQuote({ id }: QuoteTableData, manualResourceId = null) {
    const data: ManageQuoteData = { quoteId: id, resourceId: manualResourceId || this.tableRowsById[id].resourceId, focusSectionName: !!manualResourceId }
    this.changeDetectorRef.detach()
    await openDialogGetResult(this.dialog, ManageQuoteDialogComponent, { disableClose: true, autoFocus: false, data, panelClass: 'full-screen-modal' })
    this.changeDetectorRef.reattach()
  }

  async deleteQuotes(toDelete: QuoteTableData[], event) {
    const data: ConfirmDeleteData = {
      title: `Delete ${toDelete.length} quotes`,
      rect: event.target.getBoundingClientRect(),
      para: `Are you sure you want to delete ${toDelete.length > 1 ? `all ${toDelete.length} selected quotes` : 'the selected quote'}?`,
      dialog: this.dialog
    }
    const del = await openConfirmDeleteGetResult(data)
    if (!del) return

    this.quotesService.deleteQuotesFromBudget(this.budget, toDelete.map(QTD => QTD.id), this.resources)

  }

  loadCondensed() {
    this.condensed = loadLocal(`${this.filterPage}:${toggleFilterTypes.condensed}`, false)
  }

}
